@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ListItem {
  margin: 0;
  padding: 0;
  list-style-type: none;
  height: 100%;
  overflow-y: auto;
  border-radius: 6px;

  li::marker {
    color: $theme-color-text;
    font-size: $font-size-normal;
    font-weight: $font-weight-semibold;
  }
}
